import { OrderCreateRequest } from 'schema'

import { DEFAULT_CARGO_ITEM, DEFAULT_CARGO_TOTAL_ITEM } from '../../components/OrderCreate/constants'
import { OrderGuestCreateFormData } from './types'

export const INITIAL_VALUES: OrderGuestCreateFormData = {
  departureDate: '',
  departurePoint: undefined,
  destinationPoint: undefined,
  // @ts-ignore
  cargo: [DEFAULT_CARGO_ITEM],
  // @ts-ignore
  cargoTotal: DEFAULT_CARGO_TOTAL_ITEM,
  cargoType: OrderCreateRequest.cargoType.SEPARATE,
  operation: undefined,
  username: undefined
}
